import React from "react";
import logoCropped from "../../assets/logoCropped.png";
import styles from "./SubHeader.module.scss";

export const SubHeader = ({ overviewStyle }: { overviewStyle: boolean }) => {
  return (
    <div
      id={!overviewStyle ? styles.stylishContainer : styles.no}
      className={styles.container}
    >
      <img className={styles.logo} src={logoCropped} alt="logo" />
      <div className={styles.menuContainer}>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/contactUs"
        >
          Contactanos
        </a>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/blog"
        >
          Blog
        </a>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/gallery"
        >
          Galeria
        </a>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/properties"
        >
          Propiedades
        </a>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/aboutUs"
        >
          Nosotros
        </a>
        <a
          className={`${
            !overviewStyle ? styles.stylishMenuItem : styles.menuItem
          }`}
          href="/home"
        >
          Inicio
        </a>
      </div>
    </div>
  );
};
